<template>
  <v-card class="back" style="height: 680px">
    <v-layout column fill-height>
      <scroll-area>
        <template slot="header">
          <v-toolbar dark color="primary" flat dense>
            <v-toolbar-title>
              <span class="body-2 text-uppercase">{{$t('update')}} {{getData.name}} </span>
            </v-toolbar-title>
          </v-toolbar>
        </template>
        <template slot="body">
          <v-form ref="module-update-form" style="height: 100%">
            <v-layout column fill-height justify-start pa-2>
              <v-layout v-if="getFields" shrink px-0 pb-2>
                <v-flex xs4 shrink px-0 pb-2>
                  
                  <v-text-field
                    :value="$t('name')"
                    light
                    outline
                    flat
                    readonly
                    disabled
                    class="backgrey"
                    hide-details
                    :rows="1"
                    color="white"
                  >
                
                  </v-text-field>

                </v-flex>
                <v-flex xs8 shrink px-0 pb-2>
                        
                  <v-text-field
                    :data-testid="$options.name + '__text-field__' + 'name'"
                    v-model="model.obj.name"
                    light
                    auto-grow
                    outline
                    :rules="model.fields.name && model.fields.name.required ? [value => !!value || $t('required')] : []"
                    class="white"
                    hide-details
                    :rows="1"
                    color="accent"
                  >
                
                  </v-text-field>

                </v-flex>
              </v-layout>

            <v-expansion-panel
              light
              flat
              v-for="(bridge, name) in getBridges" :key="'bridge_' + name"
            >
              <v-expansion-panel-content expand-icon="" style="background-color: white; border: solid 1px #EBEBEB">
                <template v-slot:header>
                  <v-layout justify-start align-center 
                  :data-testid="$options.name + '__expansion-panel-content__' + bridge"
                  @click="() => exPanelClick(bridge)">
                    <v-icon :style="exPanel == bridge ? 'transform: rotate(-180deg);' : ''">expand_more</v-icon>
                    <v-flex shrink px-3>
                      <span class="body-2 text-uppercase">{{$t(bridge)}}</span>
                    </v-flex>
                  </v-layout>
                </template>
                <v-card style="max-height: 2000px">               
                  <v-flex v-for="(field, name) in getFields" :key="bridge + '_' + name">
                    <v-flex shrink px-0 v-if="field.group == bridge && field.show == 'true' && (field.type == 'text' || field.type == 'integer')">
                      
                      <v-layout shrink px-2>
                        <v-flex xs4 shrink px-0 pb-2>

                          <v-text-field
                            :value="$t(field.name)"
                            light
                            outline
                            flat
                            readonly
                            disabled
                            class="backgrey"
                            persistent-hint
                            hide-details
                            :rows="1"
                            color="white"
                          >
                        
                          </v-text-field>
    
                        </v-flex>
                        <v-flex xs8 shrink px-0 pb-2>
                                
                          <v-text-field
                            v-if="field.type == 'integer'"
                            :data-testid="$options.name + '__text-field__' + field.name"
                            v-model.number="model.obj[field.name]"
                            light
                            auto-grow
                            outline
                            :type="field.hide_pass ? 'password' : 'number'"
                            :rules="model.fields[field.name] && model.fields[field.name].required ? [value => !!value || $t('required')] : []"
                            class="white"
                            persistent-hint
                            hide-details
                            :rows="1"
                            color="accent"
                          >
                            <template v-slot:append-outer>
                              <v-flex xs12>
                              </v-flex>
                            </template>
                        
                          </v-text-field>

                          <v-text-field
                            v-else
                            :data-testid="$options.name + '__text-field__' + field.name"
                            v-model="model.obj[field.name]"
                            light
                            auto-grow
                            outline
                            :type="field.hide_pass ? 'password' : 'text'"
                            :rules="model.fields[field.name] && model.fields[field.name].required ? [value => !!value || $t('required')] : []"
                            :suffix="model.fields[field.name].unit"
                            :prepend-inner="model.fields[field.name].unit"
                            class="white"
                            persistent-hint
                            hide-details
                            :rows="1"
                            color="accent"
                          >
                          <template v-slot:append-outer>
                            <v-flex xs12>
                            </v-flex>
                          </template>
                          </v-text-field>
    
                        </v-flex>
                      </v-layout>
                    </v-flex>

                    <v-flex shrink v-show="!field.fields && field.show == 'true' && (field.type == 'select' || field.type == 'select_enum') && field.group == bridge" pl-0 >                   
                      <v-layout shrink v-show="checkShowVersion(field)" px-2>
                        <v-flex xs4 v-if="!field.fields && field.show == 'true' && (field.type == 'select' || field.type == 'select_enum') && field.group == bridge" shrink px-0 pb-2>

                          <v-text-field
                            :value="$t(field.name)"
                            light
                            outline
                            flat
                            readonly
                            disabled
                            class="backgrey"
                            persistent-hint
                            hide-details
                            :rows="1"
                            color="white"
                          >

                          </v-text-field>

                        </v-flex>
                        <v-flex xs8 v-if="(field.type == 'select' || field.type == 'select_enum') && field.show == 'true' && field.group == bridge && field.name != 'template' && field.name.substring(0, 1) != '$'" shrink px-0 pb-2>

                          <v-select
                            :data-testid="$options.name + '__select__' + field.name"
                            v-model="model.obj[field.name]"
                            light
                            :rules="model.fields[field.name] && model.fields[field.name].required ? [value => !!value || $t('required')] : []"
                            :items="getItems[field.cls]"
                            :item-text="field.type == 'select' ? 'name' : 'value'"
                            :item-value="field.type == 'select' ? '$id' : 'id'"
                            outline
                            hide-details
                            class="white"
                            background-color="backgrey"
                            clearable
                          >
                            <template v-slot:item="{ item, index }">
                                <span>{{ $t(field.type == 'select' ? item.name : item.value) }}</span>
                            </template>
                            <template v-slot:selection="{ item, index }">
                                <span>{{ $t(field.type == 'select' ? item.name : item.value) }}</span>
                            </template>
                          </v-select>

                        </v-flex>
                      </v-layout>
                    </v-flex>

                    <v-flex shrink v-if="field.fields" pl-0 >                  
                      <v-flex v-for="(sfield, name) in field.fields" :key="'s' + name" v-show="sfield.show == 'true' && sfield.name != 'name'" v-if="sfield.group == bridge" pa-0>
                        <v-flex shrink v-if="sfield.type == 'text' || sfield.type == 'integer'" pl-0 >                       
                          <v-layout shrink v-show="checkShowVersion(sfield)" px-2>

                            <v-flex xs4 shrink px-0 pb-2>
                              
                              <v-text-field
                                :value="$t(sfield.name)"
                                light
                                outline
                                flat
                                readonly
                                disabled
                                class="backgrey"
                                persistent-hint
                                hide-details
                                :rows="1"
                                color="white"
                              >

                              </v-text-field>

                            </v-flex>
                            <v-flex xs8 shrink px-0 pb-2>
                                    
                              <v-text-field
                                v-if="sfield.type == 'integer'"
                                :data-testid="$options.name + '__text-field__' + field.name + sfield.name"
                                v-model.number="model.obj[field.name][sfield.name]"
                                :type="sfield.hide_pass ? 'password' : 'number'"
                                :suffix="sfield.unit"
                                light
                                auto-grow
                                outline
                                class="white"
                                persistent-hint
                                hide-details
                                :rows="1"
                                color="accent"
                              >

                              </v-text-field>
                              <v-text-field
                                v-else
                                :data-testid="$options.name + '__text-field__' + field.name + sfield.name"
                                v-model="model.obj[field.name][sfield.name]"
                                :type="sfield.hide_pass ? 'password' : 'text'"
                                :suffix="sfield.unit"
                                light
                                auto-grow
                                outline
                                class="white"
                                persistent-hint
                                hide-details
                                :rows="1"
                                color="accent"
                              >

                              </v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex shrink v-if="sfield.group == bridge && (sfield.type == 'select' || sfield.type == 'select_enum')"  px-2 >
                          <v-layout shrink v-show="checkShowVersion(sfield)">
                            <v-flex xs4 shrink px-0 pb-2>
                                    
                              <v-text-field
                                :value="$t(sfield.name)"
                                light
                                outline
                                flat
                                readonly
                                disabled
                                class="backgrey"
                                persistent-hint
                                hide-details
                                :rows="1"
                                color="white"
                              >

                              </v-text-field>

                            </v-flex>
                            <v-flex xs8 shrink px-0 pb-2>

                              <v-select
                                :data-testid="$options.name + '__select__' + field.name + sfield.name"
                                v-model="model.obj[field.name][sfield.name]"
                                light
                                :rules="model.fields[field.name] && model.fields[field.name].required ? [value => !!value || $t('required')] : []"
                                :items="getItems[sfield.cls]"
                                :item-text="sfield.type == 'select' ? 'name' : 'value'"
                                :item-value="sfield.type == 'select' ? '$id' : 'id'"
                                outline
                                hide-details
                                class="white"
                                background-color="backgrey"
                                clearable
                              >
                                <template v-slot:item="{ item, index }">
                                    <span>{{ $t(sfield.type == 'select' ? item.name : item.value) }}</span>
                                </template>
                                <template v-slot:selection="{ item, index }">
                                    <span>{{ $t(sfield.type == 'select' ? item.name : item.value) }}</span>
                                </template>
                              </v-select>

                            </v-flex>

                          </v-layout>

                        </v-flex>

                        <v-flex shrink v-if="sfield.group == bridge && sfield.type == 'boolean'"  pl-2 >

                          <v-checkbox v-show="checkShowVersion(sfield)" small light color="secondary" 
                          :data-testid="$options.name + '__checkbox__' + sfield.name"
                          v-model="model.obj[field.name][sfield.name]">
                            <template v-slot:label>
                              <span class="black--text">{{$t(sfield.name)}}</span>
                            </template>
                          </v-checkbox>

                        </v-flex>
                      </v-flex>
                    </v-flex>
                  </v-flex>

                  <v-flex xs12 v-if="!field.fields" v-for="(field, name) in getFields" :key="bridge + '_boolean_' + name" pl-2>
                    <v-checkbox
                      small
                      light
                      color="secondary"
                      v-if="field.place == 'config' && field.show == 'true' && field.group == bridge && field.type == 'boolean'"
                      v-show="checkShowVersion(field)"
                      :data-testid="$options.name + '__checkbox__' + field.name"
                      v-model="model.obj[field.name]"
                    >
                      <template v-slot:label>
                        <span class="black--text" v-if="model.fields[field.name] && model.fields[field.name].required">{{$t(field.name) + ' *'}}</span>
                        <span class="black--text" v-else>{{$t(field.name)}}</span>
                      </template>
                    </v-checkbox>
                  </v-flex>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-layout shrink column  ma-0 pt-2>
              <v-flex shrink v-if="getFields && model.bridges" v-for="(field, name) in getFields" :key="'config_'+ name" pa-0>
                <v-flex shrink v-if="field.fields" v-for="(sfield, name) in field.fields" :key="'config_s_'+ name" pa-0>
                  <v-flex shrink v-if="sfield.place == 'config' && sfield.show == 'true' && !sfield.group && (sfield.type == 'select' || sfield.type == 'select_enum')">                 
                    <v-layout shrink v-show="checkShowVersion(sfield)">

                      <v-flex xs4 shrink px-0 pb-2>
                        
                        <v-text-field
                          :value="$t(sfield.name)"
                          light
                          outline
                          flat
                          readonly
                          disabled
                          class="backgrey"
                          hide-details
                          :rows="1"
                          color="white"
                        >

                        </v-text-field>

                      </v-flex>
                      <v-flex xs8 shrink px-0 pb-2>

                        <v-select
                          :data-testid="$options.name + '__select__' + field.name + sfield.name"
                          v-model="model.obj[field.name][sfield.name]"
                          light
                          :items="getItems[sfield.cls]"
                          :item-text="sfield.type == 'select' ? 'name' : 'value'"
                          :item-value="sfield.type == 'select' ? '$id' : 'id'"
                          outline
                          hide-details
                          class="white"
                          background-color="backgrey"
                          clearable

                        >
                          <template v-slot:item="{ item, index }">
                              <span>{{ $t(sfield.type == 'select' ? item.name : item.value) }}</span>
                          </template>
                          <template v-slot:selection="{ item, index }">
                              <span>{{ $t(sfield.type == 'select' ? item.name : item.value) }}</span>
                          </template>
                        </v-select>

                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-flex>
              </v-flex>
              </v-layout>

              <v-layout shrink column  py-0>
                <v-flex shrink v-for="(field, name) in getFields" :key="'other' + name" v-if="field.place == 'config' && field.show == 'true' && !field.group && (field.type == 'text' || field.type == 'integer')" v-show="checkShowVersion(field)">
                  <v-flex shrink px-0 >
                    <v-layout v-show="checkShowVersion(field)" shrink>

                      <v-flex xs4 shrink px-0 pb-2>
                        
                        <v-text-field
                          :value="model.fields[field.name] && model.fields[field.name].required ? $t(field.name) + ' *' : $t(field.name)"
                          light
                          outline
                          flat
                          readonly
                          disabled
                          class="backgrey"
                          hide-details
                          :rows="1"
                          color="white"
                        >

                        </v-text-field>

                      </v-flex>
                      <v-flex xs8 shrink px-0 pb-2>
                              
                        <v-text-field
                          v-if="field.type == 'integer'"
                          :data-testid="$options.name + '__text-field__' + field.name"
                          v-model.number="model.obj[field.name]"
                          :type="field.hide_pass ? 'password' : 'number'"
                          light
                          auto-grow
                          outline
                          :rules="model.fields[field.name] && model.fields[field.name].required ? [value => !!value || $t('required')] : []"
                          :suffix="model.fields[field.name].unit"
                          class="white"
                          persistent-hint
                          hide-details
                          :rows="1"
                          color="accent"
                        >
                        </v-text-field>

                        <v-text-field
                          v-else
                          :data-testid="$options.name + '__text-field__' + field.name"
                          v-model="model.obj[field.name]"
                          :type="field.hide_pass ? 'password' : 'text'"
                          light
                          auto-grow
                          outline
                          :rules="model.fields[field.name] && model.fields[field.name].required ? [value => !!value || $t('required')] : []"
                          :suffix="model.fields[field.name].unit"
                          class="white"
                          persistent-hint
                          hide-details
                          :rows="1"
                          color="accent"
                        >
                        </v-text-field>

                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-flex>

                <v-flex shrink v-for="(field, name) in getFields" :key="'config_'+ name" >
                  <v-flex shrink v-if="field.place == 'config' && field.show == 'true' && !field.group && (field.type == 'select' || field.type == 'select_enum')">                   
                    <v-layout shrink v-show="checkShowVersion(field)">
                      <v-flex xs4 shrink px-0 pb-2>
                              
                        <v-text-field
                          :value="$t(field.name)"
                          light
                          outline
                          flat
                          readonly
                          disabled
                          class="backgrey"
                          hide-details
                          :rows="1"
                          color="white"
                        >

                        </v-text-field>

                      </v-flex>
                      <v-flex xs8 shrink px-0 pb-2>

                        <v-select
                          :data-testid="$options.name + '__select__' + field.name"
                          v-model="model.obj[field.name]"
                          light
                          :items="getItems[field.cls]"
                          :item-text="field.type == 'select' ? 'name' : 'value'"
                          :item-value="field.type == 'select' ? '$id' : 'id'"
                          outline
                          hide-details
                          class="white"
                          background-color="backgrey"
                          clearable
                        >
                          <template v-slot:item="{ item, index }">
                              <span>{{ $t(field.type == 'select' ? item.name : item.value) }}</span>
                          </template>
                          <template v-slot:selection="{ item, index }">
                              <span>{{ $t(field.type == 'select' ? item.name : item.value) }}</span>
                          </template>
                        </v-select>

                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-flex>

                <v-flex shrink v-for="(field, name) in getFields" :key="'ping_boolean_' + name" v-if="field.place == 'config' && field.show == 'true' && !field.group && field.type == 'boolean'" pl-2>
                  <v-checkbox
                    small
                    light
                    color="secondary"
                    height="22"                
                    :data-testid="$options.name + '__checkbox__' + field.name"
                    v-model="model.obj[field.name]"
                    v-show="checkShowVersion(field)"
                  >
                    <template v-slot:label>
                      <span class="black--text" v-if="model.fields[field.name] && model.fields[field.name].required">{{$t(field.name) + ' *'}}</span>
                      <span class="black--text" v-else>{{$t(field.name)}}</span>
                    </template>
                  </v-checkbox>

                </v-flex>

              </v-layout>
            </v-layout>
          </v-form>
        </template>

        <template slot="footer">

          <v-layout fill-height dark class="primary">
            <v-layout fill-height justify-end>
              <v-btn dark small 
                :data-testid="$options.name + '__btn__' + 'close'"
                @click="() =>{$emit('close')}" color="secondary">{{$t('cancel')}}
              </v-btn>

              <v-dialog v-model="dialog.check" persistent max-width="290">
                <template v-slot:activator="{ on }">
                  <v-layout shrink fill-height justify-end>
                    <v-btn v-show="getTemplate" :data-testid="$options.name + '__btn__' + 'save'" dark small v-on="on" color="green">{{$t('save')}}</v-btn>
                  </v-layout>
                </template>
                
                <v-card>

                  <v-card-title class="blue lighten-3 caption">
                    <v-layout fill-height justify-space-around>
                      <v-flex shrink class="uppercase">
                        {{$t('device polling')}}
                      </v-flex>
                    </v-layout>
                  </v-card-title>

                  <v-card-text style="position: relative">
                    <loading-circle
                      :show="dialog.loader"
                      :size="50"
                    />
                    <v-layout column align-start px-1>
                      <v-flex v-if="!dialog.message.show" shrink>
                        {{$t('apply parameter settings?')}}
                      </v-flex>
                      <v-flex v-if="dialog.message.show" py-2>
                        <span class="uppercase">{{$t(dialog.message.text)}}</span>
                      </v-flex>
                      <v-flex v-if="dialog.message.show && dialog.message.text == 'Initialization error'" shrink>
                        {{$t('apply parameter settings?')}}
                      </v-flex>
                    </v-layout>
                  </v-card-text>

                  <v-card-actions>
                    <v-layout px-2>
                      <v-btn small block color="secondary" dark text v-if="!dialog.message.show" :data-testid="$options.name + '__!dialog-btn__' + 'cancel'" @click="closeDialogCheck">{{$t('cancel')}}</v-btn>
                      <v-btn small block color="secondary" dark text v-if="dialog.message.show" :data-testid="$options.name + '__dialog-btn__' + 'close'" @click="closeDialogCheck">{{$t('close')}}</v-btn>
                      <v-btn small block color="green" dark text v-if="dialog.message.text == '' || dialog.message.text == 'Initialization error'" :data-testid="$options.name + '__dialog-btn__' + 'yes'" @click="() => onSave(true)">{{$t('yes')}}</v-btn>
                    </v-layout>
                  </v-card-actions>

                </v-card>

              </v-dialog>
              
            </v-layout>
          </v-layout>
        </template>
      </scroll-area>
    </v-layout>
  </v-card>
</template>

<script lang="ts">
import Vue from 'vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'
import loadingCircle from '@/nms/components/partials/loader.vue'

// Типы
interface RuleItem {
  community: string
  user: string
  level: string
  authprotocol: string
  authkey: string
  privprotocol: string
  privkey: string
}

interface RulesVer3 {
  [key: string]: RuleItem
}

interface RulesSnmp {
  noVer: RuleItem
  ver1: RuleItem
  ver3: RulesVer3
}

interface RulesData {
  snmp: RulesSnmp
}

interface DialogState {
  check: boolean
  loader: boolean
  message: {
    show: boolean
    text: string
  }
}

interface ModelFields {
  [key: string]: any
}

interface ModelObj {
  snmp?: {
    version?: number
    level?: string
    [key: string]: any
  }
  [key: string]: any
}

interface ModelData {
  fields: ModelFields
  obj: ModelObj
  items?: Record<string, any>
  bridges?: Record<string, any>
  template?: any
  refs?: Record<string, { cls?: string; id?: string }>
  [key: string]: any
}

interface MetaData {
  refs?: any[]
  [key: string]: any
}

interface ModuleData {
  $id?: string
  cls?: string
  template?: string
  snmp?: {
    version?: number
    level?: string
    [key: string]: any
  }
  [key: string]: any
}

interface TemplateItem {
  [key: string]: any
}

interface ValidationResult {
  $id?: string
  valid: any
}

export default Vue.extend({
  name: 'MODULE_UPDATE_CARD',

  components: {
    scrollArea,
    loadingCircle
  },

  props: {
    data: {
      type: Object as () => ModuleData,
      default: () => ({})
    },
  },

  data(): {
    meta: MetaData | null
    exPanel: any | null
    model: ModelData
    rules: RulesData
    currentSnmpVer: number | null
    currentSnmpLevel: string | null
    dialog: DialogState
  } {
    return {
      meta: null,
      exPanel: null,
      model: {},
      currentSnmpVer: null,
      currentSnmpLevel: null,
      dialog: {
        check: false,
        loader: false,
        message: {
          show: false,
          text: ''
        },
      },
    }
  },

  computed: {
    getData(): ModuleData {
      return this.data
    },
    getItems(): Record<string, any> | undefined {
      return this.model.items
    },
    getTemplate(): any {
      return this.model.template
    },
    getFields(): ModelFields {
      return this.model.fields
    },
    getBridges(): string[] {
      return this.model.bridges ? Object.keys(this.model.bridges) : []
    },
    getVersion(): number | null {
      return this.model?.obj?.snmp?.version || this.getData.snmp?.version || null
    },
  },

  created(): void {
    this.setup()
  },

  methods: {
    setup(): void {
      this.loadMeta()
    },

    async loadMeta(): Promise<void> {
      const type = this.getData.cls || 'module'
      const temp = this.getData.template

      try {
        this.setLoader('loadMeta', true)
        const templates = await this.$bridge.getTemplates(type, { id: temp }) as TemplateItem[]
        this.meta = await this.$loadMeta(type, temp)

        if (this.meta) {
          console.log(this.$options.name, 'loadMeta', 'this.meta', this.meta)
          this.model = await this.$prepareMeta(this.meta, this.$options.name)
          this.$set(this.model, 'template', templates[0])
          this.prepareData()
        }
        this.setLoader('loadMeta', false)
      } catch (err) {
        this.setLoader('loadMeta', false)
      }
    },

    async prepareData(): Promise<void> {
      try {
        const model = await this.$prepareData(this.model, this.getData, this.meta)
        console.log(this.$options.name, 'prepareData', 'model', model)
        // console.log(this.$options.name, 'prepareData', 'getData', this.getData)
        this.model = model
        if (this.getData.$id) {
          this.$set(this.model.fields, '$id', this.getData.$id)
        }
      } catch (error) {
        console.error('CATCH', 'MODULE_UPDATE_CARD', 'prepareData', 'SMTH WRONG', error)
      }
    },

    checkShowVersion(field: { name?: string; group?: string }): boolean {
      const version = this.getVersion
      if (!version) return false
      if (!field.name || field.group !== 'snmp') return true

      const val = field.name

      if (version == 1 || version == 2) {
        const ruleValue = this.$store.getters.getDeviceNails.update.rules.snmp.ver1[val as keyof RuleItem]
        if (ruleValue) {
          return ruleValue == 'true'
        }
        return true
      }

      if (version == 3) {
        const level = this.model.obj?.snmp?.level || this.data.snmp?.level
        let ruleValue: string

        if (!level) {
          ruleValue = this.$store.getters.getDeviceNails.update.rules.snmp.ver3['no auth, no privacy'][val as keyof RuleItem]
          return ruleValue ? ruleValue == 'true' : true
        } else {
          ruleValue = this.$store.getters.getDeviceNails.update.rules.snmp.ver3[level]?.[val as keyof RuleItem]
          return ruleValue ? ruleValue == 'true' : true
        }
      }

      return false
    },

    async closeDialogCheck(): Promise<void> {
      this.$set(this.dialog, 'check', false)
    },

    async closePolling(): Promise<void> {
      this.dialog.check = false
      await this.onSave(true)
      setTimeout(() => {
        this.dialog.message.show = false
        this.$set(this.dialog.message, 'text', '')
      }, 500)
    },

    validateForm(): ValidationResult {
      console.log(this.$options.name, 'validateForm', 'this.$refs', this.$refs)
      const formRef = this.$refs['module-update-form'] as any
      const v = formRef?.validate() ?? false
      console.log(this.$options.name, 'validateForm', 'v', v)

      const obj: Record<string, any> = {}
      Object.keys(this.model.obj).forEach(key => {
        obj[key] = this.model.obj[key]
      })

      if (this.meta?.refs?.length) {
        const refs: Array<{ ref: string; cls?: string; id?: string }> = []
        Object.keys(this.model.refs || {}).forEach(ref => {
          const refItem = this.model.refs?.[ref]
          if (refItem) {
            refs.push({
              ref: ref,
              cls: refItem.cls,
              id: refItem.id
            })
          }
        })
        obj.refs = refs
      }

      console.log(this.$options.name, 'validateForm', 'obj', obj)
      return v ? { $id: this.data.$id, valid: obj } : { $id: this.data.$id, valid: v }
    },

    async onSave(polling?: boolean): Promise<void> {
      console.log(this.$options.name, 'onSave', 'polling', polling)

      try {
        console.log(this.$options.name, 'onSave', 'start')
        this.setLoader('onSave', true)
        let inited
        const valid = this.validateForm()
        if (!valid.valid) {
          console.log(this.$options.name, 'onSave', '!valid', valid)
          this.$dialog.notify.error('Ошибка обновлния параметров', { timeout: 2000 })
          return
        }

        const data_$ = Object.assign({}, valid.valid)
        const obj$ = await this.$bridge.getObjectById(valid.$id)
        const data$: Record<string, any> = {}

        Object.keys(data_$).forEach(key => {
          data$[key] = data_$[key]
        })

        this.setLoader('onSave', false)
        this.setLoader('updateDevice', true)

        let u = await obj$.update(data$)

        if (u) {
          this.$dialog.notify.success('Параметры успешно обновлены', { timeout: 5000 })
          if (polling) {
            inited = await this.initPolling(u)
          }

          if(inited && this.model.template?.hasOwnProperty('table.children')) {
            await this.$dialog.confirm({
              text: `Выполнить создание структуры для ${u.name}?`,
              title: 'Автоматическое создание структуры',
              actions: {
                false: 'Отмена',
                true: {
                  color: 'green',
                  text: 'Создать',
                  handle: async () => {
                    let queryChildrensTables = await this.$bridge.customQuery('alarm', '/collector_snmps/queryChildrensTables', {nodeId: u.$id}, 'post')
                    console.log(this.$options.name, 'onSave', 'queryChildrensTables', queryChildrensTables)
                    if(queryChildrensTables) {
                      u = await this.$bridge.getObjectById(u.$id)
                      let rePoll = await this.initPolling(u)
                      console.log(this.$options.name, 'onSave', 'queryChildrensTables obj', u, 'rePoll', rePoll)
                    }
                  }
                }
              }
            })
          }

          this.dialog.check = false
          console.log(this.$options.name, 'onSave', 'u', u)
          this.$emit('update', u)
          this.$emit('close')
        } else {
          this.$dialog.notify.success('Ошибка обновления параметров', { timeout: 5000 })
        }

        this.setLoader('updateDevice', false)
      } catch (error) {
        console.error('CATCH', 'MODULE_UPDATE_CARD', 'onSave', 'SMTH WRONG', error)
        this.$dialog.notify.success('Ошибка обновления параметров', { timeout: 5000 })
        this.setLoader('onSave', false)
        this.setLoader('updateDevice', false)
        this.$errorHandler(error)
      }
    },

    async initPolling(val?: ModuleData): Promise<void> {
      console.log(this.$options.name, 'initPolling', 'getData', this.getData)
      // console.log(this.$options.name, 'initPolling', 'model', this.model)

      let inited
      const obj = val || this.getData
      this.dialog.loader = true
      this.dialog.message.show = false
      this.dialog.message.text = ''

      const obj$ = await this.$bridge.getObjectById(obj.$id)
      if (obj$) {
        try {
          console.log(this.$options.name, 'initPolling', 'obj$', obj$)
          this.setLoader('initPolling', true)
          inited = await obj$.initPolling()
          console.log(this.$options.name, 'initPolling', 'inited', inited)
          this.dialog.loader = false
          this.setLoader('initPolling', false)
          
        } catch (error) {
          this.setLoader('initPolling', false)
          this.dialog.loader = false
        }
      } else {
        this.setLoader('initPolling', false)
        this.dialog.loader = false
        setTimeout(() => this.closePolling(), 1000)
      }
      return inited
    },

    setLoader(name: string, status: boolean): void {
      this.$store.dispatch('setLoader', {
        key: name,
        value: status
      })
    },

    exPanelClick(e: any): void {
      console.log(this.$options.name, 'exPanelClick', e)
      this.exPanel = this.exPanel === e ? null : e
    },
  },
})
</script>

<style lang="css" scoped>
</style>
